import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

const STATUS_LABELS = {
    draft: { label: 'BORRADOR', badge: 'badge-secondary' },
    ready: { label: 'LISTO', badge: 'badge-info' },
    sending: { label: 'ENVIANDO', badge: 'badge-warning' },
    completed: { label: 'COMPLETADO', badge: 'badge-success' },
};

const COHORT_LABELS = {
    30: 'Últimos 30 días',
    60: 'Últimos 60 días',
    120: 'Últimos 120 días',
    180: 'Últimos 180 días',
    365: 'Último año',
};

export class VerBulkWhatsappCampaignsDatatable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            myData: this.props.myData,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.myData !== this.props.myData) {
            this.setState({ myData: this.props.myData });
        }
    }

    render() {
        const { pageSize, pagination } = this.props;
        const { myData } = this.state;

        const columns = [
            {
                Header: <b>Nombre</b>,
                accessor: 'name',
                style: { textAlign: 'center' },
            },
            {
                Header: <b>Cohort</b>,
                accessor: 'cohort_days',
                style: { textAlign: 'center' },
                Cell: (row) => COHORT_LABELS[row.value] || row.value + ' días',
            },
            {
                Header: <b>Estado</b>,
                accessor: 'status',
                style: { textAlign: 'center' },
                Cell: (row) => {
                    const s = STATUS_LABELS[row.value] || { label: row.value, badge: 'badge-secondary' };
                    return <span className={`badge ${s.badge}`}>{s.label}</span>;
                },
            },
            {
                Header: <b>Destinatarios</b>,
                accessor: 'total_recipients',
                style: { textAlign: 'center' },
            },
            {
                Header: <b>Enviados</b>,
                accessor: 'sent_count',
                style: { textAlign: 'center' },
            },
            {
                Header: <b>Fallidos</b>,
                accessor: 'failed_count',
                style: { textAlign: 'center' },
                Cell: (row) => (
                    <span style={{ color: row.value > 0 ? '#e4566e' : 'inherit' }}>{row.value}</span>
                ),
            },
            {
                Header: <b>Acción</b>,
                id: 'actions',
                sortable: false,
                style: { textAlign: 'center' },
                Cell: (row) => (
                    <div>
                        <Link
                            to={`${process.env.PUBLIC_URL}/manage-bulk-whatsapp-campaign/${row.original.id}`}
                            title="Gestionar"
                        >
                            <i className="fa fa-cog" style={{ width: 35, fontSize: 20, padding: 11, color: 'rgb(40, 167, 69)' }}></i>
                        </Link>
                        <Link
                            to="#"
                            title="Eliminar"
                            onClick={() => {
                                Swal.fire({
                                    title: 'Confirmar',
                                    text: '¿Desea eliminar la campaña "' + row.original.name + '"?',
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: 'Confirmar',
                                    cancelButtonText: 'Cancelar',
                                }).then((result) => {
                                    if (result.value) {
                                        this.props.onDelete(row.original.id);
                                    }
                                });
                            }}
                        >
                            <i className="fa fa-trash" style={{ width: 35, fontSize: 20, padding: 11, color: '#e4566e' }}></i>
                        </Link>
                    </div>
                ),
            },
        ];

        return (
            <Fragment>
                <ReactTable
                    data={myData}
                    columns={columns}
                    defaultPageSize={pageSize}
                    showPagination={pagination}
                    className="-striped -highlight"
                />
            </Fragment>
        );
    }
}

export default VerBulkWhatsappCampaignsDatatable;
